import type { ComponentPropsWithoutRef } from 'react'

import styles from '@runtime/components/layout/ScoreLayout.module.scss'
import { Swatch } from '@runtime/components/ui/Swatch'

type ScoreLayoutProps = ComponentPropsWithoutRef<'div'>

export function ScoreGrid({ className, ...props }: ScoreLayoutProps) {
  const classes = ['sum-grid', styles.sumGrid, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

export function ScoreColStack({ className, ...props }: ScoreLayoutProps) {
  const classes = ['col-stack', styles.colStack, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

export function ScoreCard({ className, ...props }: ScoreLayoutProps) {
  const classes = ['sum-card', styles.sumCard, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

export function ScoreLeft({ className, ...props }: ScoreLayoutProps) {
  const classes = ['sum-left', styles.sumLeft, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

export function ScoreRight({ className, ...props }: ScoreLayoutProps) {
  const classes = ['sum-right', styles.sumRight, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

export function ScoreWinner({ className, ...props }: ScoreLayoutProps) {
  const classes = ['winner', styles.winner, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

type ScoreSwatchProps = ComponentPropsWithoutRef<'span'>

export function ScoreSwatch({ className, ...props }: ScoreSwatchProps) {
  const classes = [styles.swatch, className || ''].filter(Boolean).join(' ')
  return <Swatch className={classes} {...props} />
}

type ScoreTrophyProps = ComponentPropsWithoutRef<'span'>

export function ScoreTrophy({ className, ...props }: ScoreTrophyProps) {
  const classes = ['trophy', styles.trophy, className || '']
    .filter(Boolean)
    .join(' ')
  return <span className={classes} {...props} />
}
